export interface Segment {
  type: 'text' | 'year' | 'sequence';
  value: string;
}
export function splitNumberingModel(template: string): Segment[] {
  return template
    .split(/(\{YYYY\}|\{SEQ:\d+\})/)
    .filter(Boolean)
    .map((part) =>
      part === '{YYYY}'
        ? { type: 'year', value: '' }
        : part.startsWith('{SEQ:')
          ? { type: 'sequence', value: part.slice(5, -1) }
          : { type: 'text', value: part }
    );
}
export function joinNumberingModel(segments: Segment[]): string {
  return segments
    .map((s) =>
      s.type === 'year' ? '{YYYY}' : s.type === 'sequence' ? `{SEQ:${s.value}}` : s.value
    )
    .join('');
}
export function previewNumber(template: string, year: number, sequence: number): string | null {
  if (!Number.isSafeInteger(sequence) || sequence < 1 || sequence > 999999999999) return null;
  if (
    [...template.matchAll(/\{SEQ:([1-9]|1[0-2])\}/g)].length !== 1 ||
    !/^[\p{L}\p{N} ._-]*$/u.test(template.replace(/\{YYYY\}|\{SEQ:([1-9]|1[0-2])\}/g, ''))
  )
    return null;
  const result = template
    .replaceAll('{YYYY}', String(year))
    .replace(/\{SEQ:(\d+)\}/, (_, width: string) => String(sequence).padStart(Number(width), '0'));
  return result.length <= 50 ? result : null;
}
